import { UseQueryOptions } from 'react-query';
import { ServiceError } from '../../../../../hooks/error';
import { useCustomMutate, useCustomQuery } from '../../../../../hooks/query';
import {
  getExamResultsDetails,
  getExamResultsListing,
  postAuditApplyResit,
  postAuditViewResult,
} from '../api-services/api';
import {
  ExamPsleResultsDetailsResponse,
  ExamResultsDetailsResponse,
  ExamResultsListingResponse,
} from '../model';
import {
  CANDIDATE_KEY_GET_EXAM_RESULTS_DETAILS,
  CANDIDATE_KEY_GET_EXAM_RESULTS_LISTING,
  CANDIDATE_KEY_POST_AUDIT_APPLY_RESIT,
  CANDIDATE_KEY_POST_AUDIT_VIEW_RESULTS,
} from './keys';

export const useExamResultsListingQuery = (
  queryOptions?: UseQueryOptions<ExamResultsListingResponse[], ServiceError> | undefined
) =>
  useCustomQuery<ExamResultsListingResponse[]>(
    CANDIDATE_KEY_GET_EXAM_RESULTS_LISTING,
    () => getExamResultsListing().then((res) => res.data),
    queryOptions,
    undefined,
    false
  );

export const useExamResultsDetailsQuery = (
  examSeries: string,
  examYear: string,
  examLevel: string,
  errorHandler: (err: ServiceError) => void,
  queryOptions?:
    | UseQueryOptions<ExamResultsDetailsResponse | ExamPsleResultsDetailsResponse, ServiceError>
    | undefined
) =>
  useCustomQuery<ExamResultsDetailsResponse | ExamPsleResultsDetailsResponse>(
    [CANDIDATE_KEY_GET_EXAM_RESULTS_DETAILS, { examSeries, examYear, examLevel }],
    () => getExamResultsDetails(examSeries, examYear, examLevel).then((res) => res.data),
    {
      ...queryOptions,
      onError: (err) => {
        errorHandler(err);
      },
    }
  );

export const useAuditViewResultRequestMutation = () =>
  useCustomMutate<any>([CANDIDATE_KEY_POST_AUDIT_VIEW_RESULTS], (csrfToken) =>
    postAuditViewResult(csrfToken, undefined)
  );

export const useAuditApplyResitRequestMutation = (onSuccess: () => void) =>
  useCustomMutate<any>(
    [CANDIDATE_KEY_POST_AUDIT_APPLY_RESIT],
    (csrfToken) => postAuditApplyResit(csrfToken),
    {
      onSuccess,
    }
  );
